<template>
    <div class="q-dashboard q-dashboard--mobile grey lighten-5">
        <v-container fluid class="q-dashboard__content">
            <q-page-slider class="q-page-slider" height="auto" slug="homepage-slider"></q-page-slider>

			<div class="q-quick-links">
				<h2 class="q-quick-links__header">Quick Links</h2>

				<div class="q-quick-links__links">
					<div class="q-quick-links__links-col">
						<v-btn to="/contests" text link>Contests</v-btn>
						<v-btn to="/news" text link>News</v-btn>
	
						<template v-if="hasDivision(['Corporate'])">
							<v-btn to="/page/available-carriers" text link>Carrier Resources</v-btn>
							<v-btn to="/page/corp-calls-and-webinars" text link>Webinars</v-btn>
						</template>
	
						 <template v-else>
							 <v-btn to="/leads" text link>Leads</v-btn>
							 <v-btn to="/agents/carriers" text link>Carriers</v-btn>
						</template>
					</div>
	
					<div class="q-quick-links__links-col">
						<template v-if="hasDivision(['Corporate'])">
							<!-- <v-btn to="/page/corp-calls-and-webinars#past-calls" text link>Past Webinars</v-btn> -->
							<v-btn to="https://dfl.quility.com/auth" text link>Agency Rocket</v-btn>
							<v-btn to="/support" text link>Support</v-btn>
						</template>
	
						 <template v-else>
							 <v-btn to="/page/calls-and-webinars" text link>Join the Webinar</v-btn>
							<v-btn to="/page/calls-and-webinars#past-calls" text link>Past Webinars</v-btn>
							<v-btn to="/support" text link>Support</v-btn>
						</template>
					</div>
				</div>
			</div>
        </v-container>

        <div class="q-dashboard__search-bar px-5">
            <QSearchInput />
            <v-icon class="ml-2" v-text="'fas fa-search'" />
        </div>
    </div>
</template>

<script>
import QPageSlider from '@/components/utils/QPageSlider.vue';
import QSearchInput from '@/components/utils/QSearchInput.vue';

export default {
    name: 'DashboardMobile',

    components: {
        QPageSlider,
		QSearchInput,
    },
}
</script>

<style lang="scss">
.q-dashboard {
    height: 100%;

    &--mobile {
      display: flex;
      flex-direction: column;
    }

    &__content {
      flex: 1;
	  padding: 0 !important;
    }

    &__search-bar {
      display: flex;
      background: #F4F4F4;
    }

	.q-quick-links {
		padding: 32px 60px;

		&__header {
			margin: 0;
			font-weight: bold;
			font-size: 20px;
			line-height: 26px;
			color: #2F2F2F;
		}

		&__links {
			margin-top: 20px;
			display: flex;
			flex-wrap: wrap;
			gap: 8px 32px;

			.q-quick-links__links-col {
				flex: 0 0 auto;
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				row-gap: 8px;
			}

			.v-btn.v-btn--text {
				padding: 0 2px;
				height: 48px;
				min-width: unset;
				color: #2F2F2F;
				font-size: 16px;
				font-weight: 700;
				text-decoration-line: underline !important;
				text-decoration-thickness: 1.5px !important;
				text-underline-offset: 3.5px;
				text-transform: none;

				&::before {
					border-radius: 4px;
					background-color: transparent;
					transition-duration: 0.05s;
				}

				&:active::before {
					background-color: #F1F1F1;
					opacity: 1 !important;
				}

				&:focus:not(:active) {
					outline: 2px solid #005851;
					outline-offset: 0;
				}
	
				.v-btn__content {
					justify-content: flex-start;
				}
	
				.v-ripple__container {
					display: none !important;
				}
			}
		}
	}
}
</style>
